import React, { useState } from "react";
import { IoEyeSharp, IoLogoGithub } from "react-icons/io5";
import olx from "../assets/projects/project2.png";
import movie from "../assets/projects/project1.png";
import todo from "../assets/projects/todo.png";
import estatein from "../assets/projects/estatine.png";
import feather from "../assets/projects/feather-docs.png";
import gym from "../assets/projects/gym-fitness.png";
import rentit from "../assets/projects/rent-it.png";
import puffMarket from "../assets/projects/puff-market.png";
import clipcurve from "../assets/projects/clipcurve.png";
import auctionwave from "../assets/projects/auctionwave.png";
import ragPlayground from "../assets/projects/rag-playground.png";
import windForecast from "../assets/projects/wind-forecast.png";

export default function Projects() {
  const [activeFilter, setActiveFilter] = useState("all");

  const projectsData = [
    {
      name: "RAG Playground",
      description: "A modular, production-ready RAG pipeline built with LangChain featuring automated document ingestion, semantic chunking, and contextual metadata indexing. Implements a hybrid retrieval engine using Reciprocal Rank Fusion (RRF) with secondary reranking and conversational query rewriting.",
      liveLink: "https://playground-of-rag.vercel.app/",
      github: "https://github.com/adiabhiraj195",
      image: ragPlayground,
      tech: ["Next.js", "LangChain", "Redis", "BullMQ", "Express", "PostgreSQL", "Node.js"],
      category: "ai",
      featured: true,
    },
    {
      name: "Wind Data Forecast",
      description: "A wind power forecasting web application built with Next.js utilizing Incremental Static Regeneration (ISR), TypeScript, and Recharts. Visualizes real-time power generation and predictive energy analytics with dynamic weather APIs.",
      liveLink: "https://wind-power-forecast.vercel.app/",
      github: "https://github.com/adiabhiraj195",
      image: windForecast,
      tech: ["Next.js", "TypeScript", "Recharts", "REST API", "Tailwind CSS"],
      category: "web",
      featured: true,
    },
    {
      name: "Puff Market",
      description: "A decentralized NFT marketplace allowing users to mint, list, and trade digital assets securely on-chain. Integrated MetaMask and Ethers.js for wallet-based authentication with ERC-1167 minimal proxy factories saving 90-95% gas.",
      liveLink: "https://puff-market.vercel.app",
      github: "https://github.com/adiabhiraj195/puff-market",
      image: puffMarket,
      tech: ["Next.js", "Solidity", "Ethers.js", "Hardhat", "IPFS", "MetaMask"],
      category: "blockchain",
      featured: true,
    },
    {
      name: "Feather Docs",
      description: "A Google Docs-style collaborative editing platform with real-time multi-user synchronization via Socket.io. Implemented conflict-safe concurrent edit handling.",
      liveLink: "https://feather-documents.netlify.app/",
      github: "https://github.com/adiabhiraj195/feather-docs",
      image: feather,
      tech: ["React", "Socket.io", "Node.js", "Express.js", "MySQL"],
      category: "web",
      featured: true,
    },
    {
      name: "Rent It",
      description: "A full-featured property listing application with secure JWT-based authentication (NextAuth), server-side pagination, and optimized image delivery via Cloudinary.",
      liveLink: "https://rentiton.vercel.app/",
      github: "https://github.com/adiabhiraj195/rent-it",
      image: rentit,
      tech: ["Next.js", "TypeScript", "MongoDB", "NextAuth", "Cloudinary"],
      category: "web",
      featured: true,
    },
    {
      name: "OLX Clone",
      description: "A replica of the OLX classifieds marketplace. Supports user authentication, product listings, and real-time database updates via Firebase.",
      liveLink: "https://olx-app-aaf19.web.app/",
      github: "https://github.com/adiabhiraj195/Olx-app",
      image: olx,
      tech: ["React", "Firebase", "CSS"],
      category: "web",
    },
    {
      name: "Movie Store",
      description: "A movie search and details web application utilizing external movie APIs. Displays trending titles and supports user search queries.",
      liveLink: "https://movstore.netlify.app/",
      github: "https://github.com/adiabhiraj195/rjmovies",
      image: movie,
      tech: ["React", "REST API", "CSS"],
      category: "web",
    },
    {
      name: "ClipCurve",
      description: "A premium video SaaS platform built to streamline creators' workflows. Features high performance, custom UI, and secure database integrations.",
      liveLink: "https://clipcurve.com",
      github: "#",
      image: clipcurve,
      tech: ["Next.js", "Prisma ORM", "Tailwind CSS", "PostgreSQL"],
      category: "web",
    },
    {
      name: "AuctionWave",
      description: "An interactive real-time auction bidding platform with dynamic state updates and modern layout designed for high user engagement.",
      liveLink: "#",
      github: "#",
      image: auctionwave,
      tech: ["Next.js", "Tailwind CSS", "Socket.io"],
      category: "web",
    },
    {
      name: "Gym Fitness",
      description: "A responsive fitness and gym landing platform showcasing workouts, memberships, and trainer profiles with interactive components.",
      liveLink: "https://gym-fitness-ten.vercel.app/",
      github: "https://github.com/adiabhiraj195/gym-fitness",
      image: gym,
      tech: ["React", "CSS"],
      category: "web",
    },
    {
      name: "Estatein",
      description: "A modern real estate portal showcasing properties with advanced filtering options and sleek, high-fidelity responsive layouts.",
      liveLink: "#",
      github: "https://github.com/adiabhiraj195/estatein",
      image: estatein,
      tech: ["Next.js", "Tailwind CSS"],
      category: "web",
    },
    {
      name: "T0D0",
      description: "A clean task management application supporting CRUD operations, category tags, and persistent storage for organizing daily workflows.",
      liveLink: "https://adistodo.netlify.app",
      github: "https://github.com/adiabhiraj195/todo",
      image: todo,
      tech: ["React", "Node.js", "Express.js", "MongoDB"],
      category: "web",
    },
  ];

  const filteredProjects = projectsData.filter((project) => {
    if (activeFilter === "all") return true;
    return project.category === activeFilter;
  });

  const filterTabs = [
    { id: "all", label: "All" },
    { id: "ai", label: "AI / GenAI" },
    { id: "web", label: "Web Development" },
    { id: "blockchain", label: "Blockchain / Web3" },
  ];

  return (
    <article className="animate-fade-in" data-page="projects">
      <header className="mb-6">
        <h2 className="text-3xl font-bold font-display text-white">Projects</h2>
        <div className="w-12 h-1 bg-gradient-to-r from-violet-500 to-indigo-500 rounded-full mt-2"></div>
      </header>

      {/* Filter Tabs */}
      <div className="flex flex-wrap items-center gap-2 mb-8 border-b border-zinc-900 pb-4">
        {filterTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveFilter(tab.id)}
            className={`px-4 py-2 rounded-xl text-xs font-semibold tracking-wide transition-all duration-300 ${activeFilter === tab.id
                ? "bg-zinc-800 text-violet-400 border border-zinc-700/50 shadow-inner"
                : "text-zinc-400 hover:text-zinc-200 border border-transparent hover:bg-zinc-900/40"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {filteredProjects.map((project, idx) => (
          <div
            key={idx}
            className="glass-panel rounded-2xl overflow-hidden hover:border-zinc-700/65 transition-all duration-300 group flex flex-col h-full glow-teal/5"
          >
            {/* Image section with hover overlay */}
            <div className="relative h-48 overflow-hidden bg-zinc-900">
              <img
                src={project.image}
                alt={project.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />

              {/* Featured Badge */}
              {project.featured && (
                <span className="absolute top-3 left-3 text-[9px] font-bold tracking-wider uppercase text-violet-300 bg-violet-950/80 border border-violet-800/60 px-2.5 py-1 rounded-md backdrop-blur-sm">
                  Featured
                </span>
              )}

              {/* Hover overlay link */}
              <div className="absolute inset-0 bg-zinc-950/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-4 backdrop-blur-xs">
                {project.liveLink !== "#" && (
                  <a
                    href={project.liveLink}
                    target="_blank"
                    rel="noreferrer"
                    className="w-10 h-10 rounded-full bg-violet-600 hover:bg-violet-500 flex items-center justify-center text-white shadow-lg transition-transform duration-300 hover:scale-110"
                    title="View Live Site"
                  >
                    <IoEyeSharp className="text-lg" />
                  </a>
                )}
                {project.github !== "#" && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noreferrer"
                    className="w-10 h-10 rounded-full bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 flex items-center justify-center text-white shadow-lg transition-transform duration-300 hover:scale-110"
                    title="View Code on GitHub"
                  >
                    <IoLogoGithub className="text-lg" />
                  </a>
                )}
              </div>
            </div>

            {/* Content section */}
            <div className="p-5 flex-1 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-bold text-white font-display group-hover:text-violet-400 transition-colors">
                  {project.name}
                </h3>

                <p className="text-xs text-zinc-400 leading-relaxed mt-2.5 font-sans">
                  {project.description}
                </p>
              </div>

              {/* Tech Tags */}
              <div className="mt-5">
                <div className="flex flex-wrap gap-1.5">
                  {project.tech.map((t, index) => (
                    <span
                      key={index}
                      className="text-[9px] font-semibold text-zinc-400 bg-zinc-900/60 border border-zinc-800 px-2 py-0.5 rounded-md font-sans"
                    >
                      {t}
                    </span>
                  ))}
                </div>

                {/* Footer links for mobile / fallback */}
                <div className="flex items-center gap-4 mt-4 pt-4 border-t border-zinc-900/60 md:hidden">
                  {project.github !== "#" && (
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center gap-1.5 text-xs font-semibold text-zinc-400 hover:text-white transition-colors"
                    >
                      <IoLogoGithub className="text-sm" />
                      Code
                    </a>
                  )}
                  {project.liveLink !== "#" && (
                    <a
                      href={project.liveLink}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center gap-1.5 text-xs font-semibold text-violet-400 hover:text-violet-300 transition-colors ml-auto"
                    >
                      <IoEyeSharp className="text-sm" />
                      Live Demo
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </article>
  );
}
